import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const tagsApi = createApi({
  reducerPath: 'Tags',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['tags'],
  endpoints: (builder) => ({
    // ---------------------- GET TAGS ----------------------
    getAllTagsList: builder.query({
      query: ({ page = 1, keyword = '' }) => {
        let url = `admin/tags?pageno=${page}`;
        if (keyword) url += `&search=${keyword}`;
        return { url, method: 'GET' };
      },
      transformResponse: (res) => res,
      providesTags: ['tags'],
    }),

    getPostsByTag: builder.query({
      query: ({ page = 1, keyword = ''  , id , limit}) => {
        let url = `admin/tags/posts/${id}?pageno=${page}&limit=${limit}`;
        if (keyword) url += `&search=${keyword}`;
        return { url, method: 'GET' };
      },
      transformResponse: (res) => res?.body,
      providesTags: ['tags'],
    }),

    // ---------------------- ADD TAG ----------------------
    addTag: builder.mutation({
      query: (newTagData) => ({
        url: 'admin/tag',
        method: 'POST',
        body: newTagData,
      }),
      invalidatesTags: ['tags'],
    }),

    // ---------------------- UPDATE TAG ----------------------
    updateTag: builder.mutation({
      query: (data) => ({
        url: `admin/tag/${data?.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['tags'],
    }),

    // ---------------------- DELETE TAG ----------------------
    deleteTag: builder.mutation({
      query: (id) => ({
        url: `admin/tag/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['tags'],
    }),
  }),
});

export const {
    useGetAllTagsListQuery,
    useAddTagMutation,
    useUpdateTagMutation,
    useDeleteTagMutation,
    useGetPostsByTagQuery
  } = tagsApi;
